<script setup lang="ts">

import {apps, useOrderViewContext} from "@hantera/portal-app";
import Invoice from "@/components/Order/Invoices/Invoice.vue";
import AppSlotView from "@/AppSlotView.vue";

const orderViewContext = useOrderViewContext();

</script>

<template>

  <div class="toolbar neat-scroll">
    <AppSlotView :slot="apps.orderViewSlots.toolbars.invoices" />
  </div>
  
  <div class="invoices">
    
    <Invoice
      v-for="invoice in orderViewContext.state.invoices"
      :key="invoice.invoiceId"
      :invoice="invoice"
    />
  </div>

</template>

<style scoped>

.invoices {
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: min-content;
  gap: 10px;
  margin: 10px;
}

</style>